import { getAuxValueById } from 'RestAPIs/AuxiliaryValues';
import useResource from 'components/shared/hooks/useResource';
import { mergeAll } from 'ramda';
import { isAuxValueUnused } from '../utils/utils';

import type { AuxValue } from 'RestAPIs/AuxiliaryValues';
import type { AuxFormValues } from '../Form/AuxValuesForm.types';

const getAuxFormValues = (auxValue: AuxValue): AuxFormValues => {
  return {
    auxValueId: auxValue.auxValueId,
    code: auxValue.code,
    colorCode: auxValue.colorCode,
    auxValueGroupId: auxValue.auxValueGroupId,
    auxValueGroupName: auxValue.auxValueGroupName,
    notInUse: isAuxValueUnused(auxValue.flags),
    sortOrder: auxValue.sortOrder,

    //@ts-ignore
    translations: mergeAll(
      auxValue.translations.map((item) => {
        return { [item.languageCode]: item.name };
      })
    )
  };
};

const useGetAuxValueById = (id: number) => {
  'use memo';

  const { resource, isFetching } = useResource({
    fetcher: () => getAuxValueById(id),
    transformer: (response) => getAuxFormValues(response)
  });

  return { resource: resource ? resource : undefined, isFetching };
};

export default useGetAuxValueById;
